<template>
    <kt-panel>
        <div class="create-services">
            <router-link to="/online-factor-item-create">
                <button class="btn btn-success">ایجاد محصول</button>
            </router-link>
             <router-link to="/receive-money" class="mr-2">
                <button class="btn btn-success">بازگشت</button>
            </router-link>
        </div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card online-factor-search-bar" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="subset_name">
                                                {{ $t('online-factor.title_item')}}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="title"
                                                name="title"
                                                id="title"
                                                v-model="query.title"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="subset_name">
                                                {{ $t('online-factor.item_code')}}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="item_code"
                                                name="item_code"
                                                id="item_code"
                                                v-model="query.item_code"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('online-factor.factor_category') }}
                                            </kt-form-label>
                                            <kt-form-select
                                            v-model ="query.archive">
                                            <option
                                                value="false"
                                            >
                                                {{ $t('online-factor.active') }}
                                            </option>
                                            <option
                                                value="true"
                                            >
                                                {{ $t('online-factor.archive') }}
                                            </option>
                                            </kt-form-select>

                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true
        }
    },
    data() {
        return {
            query: {
                archive: "false"
            },
        }
    },
    methods: {

    },
     mounted(){
        this.query.archive = "false"
    }
}

</script>

<style scoped>
.create-services {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
</style>